/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const CopyIcon = ({
  className,
  style: styleFromProps,
  color = '#ADA9BB',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3807 2.31824L14.5568 0.494262C14.2403 0.177794 13.8111 2.34027e-06 13.3635 0L7.3125 0C6.38051 0 5.625 0.755508 5.625 1.6875V3.375H2.8125C1.88051 3.375 1.125 4.13051 1.125 5.0625V16.3125C1.125 17.2445 1.88051 18 2.8125 18H10.6875C11.6195 18 12.375 17.2445 12.375 16.3125V14.625H15.1875C16.1195 14.625 16.875 13.8695 16.875 12.9375V3.51148C16.875 3.06392 16.6972 2.6347 16.3807 2.31824ZM13.5 1.14226C13.5989 1.16667 13.6893 1.21767 13.7612 1.28974L15.5852 3.11375C15.6573 3.18575 15.7083 3.2761 15.7327 3.375H13.5V1.14226ZM11.25 16.3125C11.25 16.6226 10.9976 16.875 10.6875 16.875H2.8125C2.50235 16.875 2.25 16.6226 2.25 16.3125V5.0625C2.25 4.75235 2.50235 4.5 2.8125 4.5H5.625V12.9375C5.625 13.8695 6.38051 14.625 7.3125 14.625H11.25V16.3125ZM15.75 12.9375C15.75 13.2476 15.4976 13.5 15.1875 13.5H7.3125C7.00235 13.5 6.75 13.2476 6.75 12.9375V1.6875C6.75 1.37735 7.00235 1.125 7.3125 1.125H12.375V3.65625C12.375 4.12031 12.7547 4.5 13.2188 4.5H15.75V12.9375Z"
        fill={color}
      />
    </svg>
  );
};
